import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Loader} from './Loader';
import NoResult from './NoResult';

import '../assets/stylesheets/List.scss';

export default class List extends Component {

    static propTypes = {
        loader: PropTypes.bool,
        counter: PropTypes.number,
        messageEmpty: PropTypes.string
    };

    static defaultProps = {
        messageEmpty: "Não existem itens cadastrados."
    };

    render() {

        const {
            loader,
            counter,
            children,
            messageEmpty
        } = this.props;

        if (loader === true) {
            return <Loader inverted />;
        } else if (counter === 0) {
            return <NoResult message={messageEmpty} />;
        } else {
            return <div className="List">{children}</div>;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/List.js